﻿import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import type { ImportJob, ImportJobsResponse } from '../types/import';

function isActive(status: ImportJob['status']) {
  return status === 'pending' || status === 'processing';
}

export function useImportJobs() {
  return useQuery({
    queryKey: ['import-jobs'],
    queryFn: () => api<ImportJobsResponse>('/import'),
    refetchInterval: (q) => {
      const data = q.state.data;
      if (!data?.items?.length) return false;
      return data.items.some((j) => isActive(j.status)) ? 3000 : false;
    },
  });
}

export function useImportJob(jobId: string | undefined) {
  return useQuery({
    queryKey: ['import-job', jobId],
    queryFn: () => api<ImportJob>(`/import/${jobId}`),
    enabled: Boolean(jobId),
    refetchInterval: (q) => {
      const st = q.state.data?.status;
      if (!st) return false;
      return st === 'pending' || st === 'processing' ? 2000 : false;
    },
  });
}
